// @generated by protoc-gen-es v1.7.0 with parameter "target=ts,import_extension=.ts"
// @generated from file plugnmeet_recording.proto (package plugnmeet, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from '@bufbuild/protobuf';
import { RecordingTasks } from './plugnmeet_recorder_pb.ts';
/**
 * @generated from message plugnmeet.RecordingReq
 */
export class RecordingReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.RecordingTasks task = 1;
         */
        this.task = RecordingTasks.START_RECORDING;
        /**
         * @generated from field: string room_id = 2;
         */
        this.roomId = '';
        /**
         * @generated from field: int64 room_table_id = 3;
         */
        this.roomTableId = protoInt64.zero;
        /**
         * @generated from field: string sid = 4;
         */
        this.sid = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RecordingReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordingReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordingReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordingReq, a, b);
    }
}
RecordingReq.runtime = proto3;
RecordingReq.typeName = 'plugnmeet.RecordingReq';
RecordingReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'task',
        kind: 'enum',
        T: proto3.getEnumType(RecordingTasks),
    },
    { no: 2, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'room_table_id',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    { no: 4, name: 'sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 5,
        name: 'rtmp_url',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 6,
        name: 'custom_design',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.RecordingInfoFile
 */
export class RecordingInfoFile extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int64 room_table_id = 1;
         */
        this.roomTableId = protoInt64.zero;
        /**
         * @generated from field: string room_id = 2;
         */
        this.roomId = '';
        /**
         * @generated from field: string room_title = 3;
         */
        this.roomTitle = '';
        /**
         * @generated from field: string room_sid = 4;
         */
        this.roomSid = '';
        /**
         * @generated from field: int64 room_creation_time = 5;
         */
        this.roomCreationTime = protoInt64.zero;
        /**
         * @generated from field: int64 room_ended = 6;
         */
        this.roomEnded = protoInt64.zero;
        /**
         * @generated from field: string recording_id = 7;
         */
        this.recordingId = '';
        /**
         * @generated from field: string recorder_id = 8;
         */
        this.recorderId = '';
        /**
         * @generated from field: string file_path = 9;
         */
        this.filePath = '';
        /**
         * @generated from field: float file_size = 10;
         */
        this.fileSize = 0;
        /**
         * @generated from field: int64 creation_time = 11;
         */
        this.creationTime = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RecordingInfoFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordingInfoFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordingInfoFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordingInfoFile, a, b);
    }
}
RecordingInfoFile.runtime = proto3;
RecordingInfoFile.typeName = 'plugnmeet.RecordingInfoFile';
RecordingInfoFile.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'room_table_id',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    { no: 2, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'room_title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'room_sid', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 5,
        name: 'room_creation_time',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    { no: 6, name: 'room_ended', kind: 'scalar', T: 3 /* ScalarType.INT64 */ },
    {
        no: 7,
        name: 'recording_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    {
        no: 8,
        name: 'recorder_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 9, name: 'file_path', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 10, name: 'file_size', kind: 'scalar', T: 2 /* ScalarType.FLOAT */ },
    {
        no: 11,
        name: 'creation_time',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
]);
